const generate_short_uuid = () => {
  return Array.from(crypto.getRandomValues(new Uint8Array(6)))
    .map((b) => b.toString(36).padStart(2, "0"))
    .join("")
    .substring(0, 8);
};

export default generate_short_uuid;
